import script from "./UpdateActivityModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateActivityModal.vue?vue&type=script&setup=true&lang=js"

import "./UpdateActivityModal.vue?vue&type=style&index=0&id=51dfe540&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51dfe540"]])

export default __exports__